import type { RichTextCustomLeaf } from '../../../types.js'

export const italic: RichTextCustomLeaf = {
  name: 'italic',
  Button: '@payloadcms/richtext-slate/client#ItalicLeafButton',
  Leaf: '@payloadcms/richtext-slate/client#ItalicLeaf',
}
